/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'EventType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('eventtype'); // main translation loaded for eventtype
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltereventtype'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/eventtype/eventtype-dialog.html';

		return {
			/* new state for entity eventType */
			/* to access: ui-ref="eventtype.list.new" */
			/* url: hostname/eventtype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'EventTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'EventTypeFactory',
									'NewEventTypeFactory',
									function(EventTypeFactory, NewEventTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return EventTypeFactory.get({ id: $stateParams.eventTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewEventTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for eventType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for eventType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('eventtype', {
		/* abstract state for entity eventType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/eventtype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'EventTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('eventtype.list', {
		/* list state for entity eventType */
		/* to access: ui-ref="eventtype.list" */
		/* url: hostname/eventtype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventtype/eventtypes.html',
				controller: 'EventTypeController',
			},
		},
	});

	$stateProvider.state('eventtype.detail', {
		/* detail state for entity eventType */
		/* to access: ui-sref="eventtype.detail" */
		/* url: hostname/eventtype/detail/:eventTypeId */
		url: '/detail/:eventTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventtype/eventtype-detail.html',
				controller: 'EventTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'EventTypeFactory',
				function($stateParams, EventTypeFactory) {
					return EventTypeFactory.get({ id: $stateParams.eventTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/eventtype/list/new */
	$stateProvider.state('eventtype.list.new', getNewState());
	/* url: http://<hostname>/eventtype/list/:eventTypeId/edit */
	$stateProvider.state('eventtype.list.edit', getEditState('/:eventTypeId/edit'));
	/* url: http://<hostname>/eventtype/detail/:eventTypeId/edit */
	$stateProvider.state('eventtype.detail.edit', getEditState('/edit'));

	$stateProvider.state('templateevent.list.newEventType', getNewState('/eventtype/new'));
});
